import * as React from 'react';
import { Link } from 'react-router-dom';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ContactErrorMessagesComponent from 'src/modules/contact/partials/ContactErrorMessages.component';

export interface ContactComponentProps {
  name: string;
  surname: string;
  email: string;
  phone: string;
  message: string;
  checkboxTerms: boolean;
  success: boolean;
  error: boolean;
  errorMessage: {};
  handleChange: (key: string) => (value: string | File | boolean) => void;
  sendForm: () => void;
  handleChangeCheckbox: () => void;
}

const ContactComponent: React.StatelessComponent<ContactComponentProps> = (props: ContactComponentProps) => {
  const googleMapRoute = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2993.001015833533!' +
    '2d2.169351615598288!3d41.395784303437125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!' +
    '1s0x12a4a3522bfa1c51%3A0x4921729bd435b125!2sSowo%20Coworking!5e0!3m2!1ses!2ses!4v1567419735651!5m2!1ses!2ses';

  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <div className="gap-20"/>
          </div>
          <div className="col-md-4">
            <p className="breadcrumb text-right">
              Inicio > Contacto
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            {!props.success ?
              <div className="simple-card padding-l-r-40 bk-w">
                <h1 className="bold-title">
                  Contacto
                </h1>
                <p>
                  ¿Tienes algo que decirnos?
                </p>
                <p>
                  ¿Dudas sobre el proceso de selección, cómo invertir, qué pasa una vez has invertido...?
                </p>
                <p>
                  <strong>
                    Puedes utilizar el siguiente formulario para contactarnos por email:
                  </strong>
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="md-input">
                      <InputContainer
                        label="Nombre"
                        type="text"
                        value={props.name ? props.name : ''}
                        onChange={(value) => props.handleChange('name')(value)}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="md-input">
                      <InputContainer
                        label="Apellido/s"
                        type="text"
                        value={props.surname ? props.surname : ''}
                        onChange={(value) => props.handleChange('surname')(value)}
                        required={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="md-input">
                      <InputContainer
                        label="Email"
                        type="text"
                        value={props.email ? props.email : ''}
                        onChange={(value) => props.handleChange('email')(value)}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="md-input">
                      <InputContainer
                        label="Teléfono"
                        type="text"
                        value={props.phone ? props.phone : ''}
                        onChange={(value) => props.handleChange('phone')(value)}
                        required={false}
                      />
                    </div>
                  </div>
                </div>
                <div className="gap-20"/>
                <div className="md-input">
                  <InputContainer
                    label=" "
                    type="textarea"
                    placeholder="Mensaje (*)"
                    value={props.message || ''}
                    required={false}
                    onChange={(value) => props.handleChange('message')(value)}
                  />
                </div>
                <div className="gap-20"/>

                <div className="checkbox">
                  <input
                    type="checkbox"
                    checked={props.checkboxTerms}
                    onChange={() => ({})}
                  />
                  <label
                    onClick={(e) => props.handleChangeCheckbox()}
                  >
                    Sí, acepto los &nbsp;
                    <Link to="/terminos-y-condiciones">
                      términos y condiciones de uso
                    </Link>
                    &nbsp; de The Crowd Angel.
                  </label>
                </div>

                <div className="gap-20"/>
                <p className="text-right">
                  <button
                    className="btn btn-success"
                    onClick={props.sendForm}
                  >
                    Enviar
                  </button>
                </p>
                <div className="gap-20" />
                <ContactErrorMessagesComponent
                  error={props.error}
                  errorMessage={props.errorMessage}
                />
                <div className="gap-20"/>
              </div> :
              <div className="simple-card padding-l-r-40 bk-w">
                <div className="gap-20"/>
                <span className="corrected-circle"/>
                <p className="text-center">
                  <strong>
                    Su mensaje se ha enviado correctamente
                  </strong>
                </p>
                <div className="gap-20"/>
              </div>
            }

          </div>
          <div className="col-sm-4" style={{backgroundColor: 'white'}}>
            <h4>
              The Crowd Angel
            </h4>
            <p>
              <strong>
                Email:
              </strong>
              <br/>
              <a href="mailto:info@thecrowdangel.com">
                info@thecrowdangel.com
              </a>
              <br/>
              <a href="mailto:support@thecrowdangel.com">
                support@thecrowdangel.com
              </a>
            </p>
            <div className="gap-20"/>
            <p>
              <strong>
                Teléfono:
              </strong>
              <br/>
              (+34) 693 234 207
            </p>
            <div className="gap-20"/>
            <p>
              <strong>
                Dirección:
              </strong>
              <br/>
              Consell de Cent, 413-415 4º2ª
              <br/>
              08009 Barcelona
            </p>
            <div className="gap-20"/>
            <p>
              <strong>
                Síguenos:
              </strong>
              <br/>
              <a
                className="rrss"
                title="Síguenos en Facebook"
                href="https://www.facebook.com/thecrowdangel/"
              >
                <img
                  alt="Facebook"
                  src="./img/facebook.png"
                />
              </a>
              <a
                className="rrss"
                title="Síguenos en Twitter"
                href="https://twitter.com/TheCrowdAngel"
              >
                <img
                  alt="Twitter"
                  src="./img/twitter.png"
                />
              </a>
              <a
                className="rrss"
                title="Síguenos en Linkedin"
                href="https://www.linkedin.com/company/thecrowdangel/"
              >
                <img
                  alt="Linkedin"
                  src="./img/linkedin.png"
                />
              </a>
            </p>
          </div>
        </div>
      </div>
      <div className="container-fluid google-map-container">
        <div className="row">
          <div className="col-sm-12 padding-l-r-0">
            <iframe
              className="google-map"
              title="Map"
              allowFullScreen={true}
              src={googleMapRoute}
              frameBorder="0"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactComponent;



// WEBPACK FOOTER //
// ./src/modules/contact/Contact.component.tsx